"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Tab = _ref => {
  let {
    className,
    children,
    selected,
    indicator,
    id,
    onClick,
    index,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    id: id,
    className: className,
    role: "tab",
    onClick: e => {
      e.currentTarget.blur();
      onClick(index);
    },
    "aria-selected": selected ? "true" : "false"
  }, props), children, indicator);
};
exports.Tab = Tab;
Tab.propTypes = {
  /** Sets this tab to be the selected tab (First tab where selected = true) */
  selected: _propTypes.PropTypes.bool,
  /** Custom CSS classes */
  className: _propTypes.PropTypes.string,
  /** Tab label content */
  children: _propTypes.PropTypes.node
};